/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Utils functions
  function getWindowWidth() {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  }

  function isDesktop() {
    return getWindowWidth() >= window.theme.sizes.small;
  }

  function isMobile() {
    return getWindowWidth() < window.theme.sizes.small;
  }

  // PDP - Sticky Add to Cart
  const stickyRadioButtons = document.querySelectorAll('.cart-bar .radio__button')

  stickyRadioButtons.forEach((radioButton) => {
    radioButton.addEventListener('click', (e) => {
      // Find matching size option in product content and trigger click
      e.preventDefault()
      const size = radioButton.dataset.size
      const sizeOption = document.querySelector(`.product__content .product__selectors .radio__button:not(.size-guide-radio)[data-size="${size}"]`)
      const sizeOptionInput = sizeOption.querySelector('input')

      sizeOptionInput.click()
    })
  })

  // mobile sticky add to cart
  const mobileStickyAddToCart = document.querySelector('.cart-bar__submit .product__submit__add')

  if (mobileStickyAddToCart) {
    mobileStickyAddToCart.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopImmediatePropagation()
      const addToCartButton = document.querySelector('.product__content .product__submit__item button[type="submit"][data-add-to-cart]')
      addToCartButton.click()
    })
  }

  // Toggle active class on sticky radio buttons
  const productContentOptions = document.querySelectorAll('.product__content .selector-wrapper:not(.gift-size-options) .radio__buttons .radio__button')

  productContentOptions.forEach((option) => {
    option.addEventListener('click', () => {
      const size = option.dataset.size
      const escapedSize = size.replace(/"/g, '\\"'); // Escape double quotes
      const stickyOption = document.querySelector(`.cart-bar .radio__button[data-size="${escapedSize}"]`)
  
      stickyRadioButtons.forEach((radioButton) => {
        radioButton.classList.remove('active')
      })
      stickyOption.classList.add('active')
      
      // set border color of active variants
      const root = document.querySelector(':root')
      root.style.setProperty('--border-PDP-variant', '#000000')

      // Size select state 
      const sizeSelects = document.querySelectorAll('.form__wrapper')
      sizeSelects.forEach((sizeSelect) => {
        sizeSelect.classList.remove('show-size-select')
      })

    })
  })

  // Trigger add to cart on sticky button click
  const stickyAddToCartButton = document.querySelector('.cart-bar__CTA .btn')

  if (stickyAddToCartButton) {
    stickyAddToCartButton.addEventListener('click', (e) => {
      e.preventDefault()
      const addToCartButton = document.querySelector('.product__content .product__submit__item button[type="submit"][data-add-to-cart]')
      addToCartButton.click()
    })
  }

  // Quick add new
  document.addEventListener('click', (e) => {
    if (e.target.closest('.radio__button')) {
      handleOptionClick(e)
    }
  })

  const handleOptionClick = (e) => {
    const productGridQuick = e.target.closest('.product-grid-quick-add')

    if (!productGridQuick) return;

    const productGrid = e.target.closest('.product-item')
    const selectedOption = e.target.getAttribute('data-size')
    const targetVariantOption = e.target.closest('.product-grid-quick-add').querySelector(`.hidden-variant-options option[data-option-two="${selectedOption}"]`)

      // add item to cart
      try {
      let formData = {
        items: [
          {
            id: parseInt(targetVariantOption.value),
            quantity: 1,
          },
        ],
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          window.cart.getCart()
          window.cart.openCartDrawer()
          productGrid.classList.remove('visible-quick-add')
        })
    } catch (error) {
      console.log(error);
    }
  }

  // quick add toggle button
  document.addEventListener('click', (e) => {
    if (e.target.closest('.quick-add__button')) {
      e.preventDefault();
      e.target.closest('.product-item').classList.add('visible-quick-add');
    }
  })

  // product grid items
  const productGridItems = document.querySelectorAll('.product-item')

  if (productGridItems && isDesktop()) {
    productGridItems.forEach((item) => {
      item.addEventListener('mouseleave', () => {
        item.classList.remove('visible-quick-add')
      })
    })
  }

  const handleAfterPayUIs = () => {
    try {
       // afterpay component
      const afterPayComponent = document.querySelector('square-placement')
      // Access the Shadow DOM
      const shadowRoot = afterPayComponent?.shadowRoot;
      const logoElement = shadowRoot?.querySelector('.afterpay-logo');
      const textElement = shadowRoot?.querySelector('.afterpay-paragraph');

      if (logoElement) {
        logoElement.style.setProperty('--logo-badge-width', '60px');
      }

      if (textElement) {
        textElement.style.setProperty('--messaging-font-size', '10px');
      }
    } catch (error) {
      console.log(error);
    }
  }

  window.theme.handleAfterPayUIs = handleAfterPayUIs;
  
  window.addEventListener('load', () => {
    handleAfterPayUIs()
  })

  document.addEventListener('click', (e) => {
    if (e.target.matches('.read-more')) {
      e.preventDefault();
      const productDescription = e.target.closest('.collection-image-with-title');
      productDescription.classList.add('expanded');
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.matches('.show-less')) {
      e.preventDefault();
      const productDescription = e.target.closest('.collection-image-with-title');
      productDescription.classList.remove('expanded');
    }
  });

  // PDP - Size guide
  const sizeGuideButtons = document.querySelectorAll('.size-charts-wrapper .variant-sizes-wrapper.size-guide-sizes .radio__button')

  sizeGuideButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault()
      const size = button.dataset.size
      const accordion = button.closest('.accordion')
      accordion.dataset.activeSize = size
      const innerSizeButtons = accordion.querySelectorAll('.variant-sizes-wrapper.size-guide-sizes .radio__button')
      innerSizeButtons.forEach((button) => {
        button.classList.remove('active')
      })
      button.classList.add('active')
    })
  })

  const sizeGuideUnitButtons = document.querySelectorAll('.size-charts-wrapper .unit-elements .radio__button')

  sizeGuideUnitButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault()
      const unit = button.dataset.unit
      const accordion = button.closest('.accordion')
      accordion.dataset.activeUnit = unit
      const innerUnitButtons = accordion.querySelectorAll('.unit-elements .radio__button')
      innerUnitButtons.forEach((button) => {
        button.classList.remove('active')
      })
      button.classList.add('active')
    })
  })

  // Navigations teams
  const navigationTeamsLinks = document.querySelectorAll('.menu__item--teams .header__dropdown__inner .dropdown__family .navlink')

  navigationTeamsLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
      const team = link.dataset.name
      const teamSection = document.querySelector(`.teams__list__wrapper .teams-blocks[data-team-name="${team}"]`)
      const teamsSections = document.querySelectorAll('.teams__list__wrapper .teams-blocks')

      navigationTeamsLinks.forEach((link) => {
        link.classList.remove('active')
      })
      link.classList.add('active')

      teamsSections.forEach((section) => {
        section.classList.remove('active')
      })
      teamSection.classList.add('active')
    })
  })


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
   $('.radio__buttons span.radio__button input[type="radio"]').on('change', function() {
            // Check if the .variant--soldout class is present
              if ($('.variant--soldout').length > 0) {
                // Update text if .variant--soldout is present
                $('.variant--soldout p.selected-size-label').text("Size Out Of Stock?");
            } else {
                // Update text if .variant--soldout is not present
                $('p.selected-size-label').text("Select Size");
            }
        });
})();
